import { render, staticRenderFns } from "./trawl-main-menu.vue?vue&type=template&id=f09ecdf6"
import script from "./trawl-main-menu.vue?vue&type=script&lang=js"
export * from "./trawl-main-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports